module.exports = __webpack_public_path__ + "static/media/YamBowl3.7120bbca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Yamamoto/YamBowl3.jpg
// module id = 5772
// module chunks = 0